export const VA_TABLE_DEFAULT_LABELS = {
  noResults: 'COMMON.TABLE.NO_RESULTS',
  cancel: 'COMMON.ACTION_LABELS.CANCEL',
  none: 'COMMON.ACTION_LABELS.NONE_LABEL',
  update: 'COMMON.ACTION_LABELS.UPDATE',
  sortBy: 'COMMON.TABLE.SORT.SORT_COLUMN_ORDER_DESCRIPTION_TEXT.SORT_BY',
  thenSortBy: 'COMMON.TABLE.SORT.SORT_COLUMN_ORDER_DESCRIPTION_TEXT.THEN_SORT_BY',
  addAnotherSortColumn: 'COMMON.TABLE.SORT.SELECT_COLUMN_PLACEHOLDER',
  chooseColumnToSortBy: 'COMMON.TABLE.SORT.SELECT_COLUMN_PLACEHOLDER_EMPTY_STATE',
  columnSorting: {
    date: {
      ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.EARLIEST_TO_LATEST',
      descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.LATEST_TO_EARLIEST',
    },
    number: {
      ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS._1_TO_9',
      descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS._9_TO_1',
    },
    string: {
      ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.A_TO_Z',
      descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.Z_TO_A',
    },
    default: {
      ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.FIRST_TO_LAST',
      descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.LAST_TO_FIRST',
    },
  },
  export: {
    buttonText: 'COMMON.TABLE.EXPORT.BUTTON',
    buttonTooltipBeforeCount: 'COMMON.TABLE.EXPORT.BUTTON_TOOLTIP_BEFORE_COUNT',
    buttonTooltipAfterCount: 'COMMON.TABLE.EXPORT.BUTTON_TOOLTIP_AFTER_COUNT',
  },
  columnSelector: {
    buttonText: 'COMMON.TABLE.COLUMN_SELECTOR.BUTTON',
  },
};
